<template>
  <div class="h-[calc(100vh-64px)] flex items-center justify-center bg-gray-100 px-4">
    <div class="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
      <h1 class="text-2xl font-bold text-center mb-6">Iniciar Sesión en InspectList</h1>

      <form @submit.prevent="handleLogin" class="space-y-6">
        <!-- Error Message -->
        <div v-if="error" class="p-4 bg-red-100 text-red-700 rounded-lg text-sm">
          Correo o contraseña inválidos
        </div>

        <!-- Email Input -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Correo
          </label>
          <input
            type="email"
            v-model="email"
            required
            class="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none"
            placeholder="Ingrese su correo"
          />
        </div>

        <!-- Password Input -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1">
            Contraseña
          </label>
          <input
            type="password"
            v-model="password"
            required
            class="w-full p-3 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-300 focus:border-blue-500 outline-none"
            placeholder="Ingrese su contraseña"
          />
        </div>

        <!-- Submit Button -->
        <button
          type="submit"
          :disabled="loading"
          class="w-full bg-blue-500 text-white py-3 px-4 rounded-lg hover:bg-blue-600 transition duration-200 flex items-center justify-center gap-2 disabled:bg-blue-300"
        >
          <span v-if="loading" class="material-icons animate-spin">refresh</span>
          {{ loading ? 'Iniciando sesión...' : 'Iniciar Sesión' }}
        </button>

        <!-- Add Reset Password Link -->
        <div class="text-center mt-4">
          <router-link to="/reset-password" class="text-blue-500 hover:text-blue-600 text-sm">
            ¿Olvidaste tu contraseña?
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useAuth } from '../firebase/auth';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const auth = useAuth();
    const router = useRouter();
    const email = ref('');
    const password = ref('');
    const error = ref('');
    const loading = ref(false);

    const handleLogin = async () => {
      try {
        loading.value = true;
        error.value = '';
        await auth.login(email.value, password.value);
        router.push('/');
      } catch (err) {
        error.value = 'Invalid email or password';
      } finally {
        loading.value = false;
      }
    };

    return {
      email,
      password,
      error,
      loading,
      handleLogin
    };
  }
};
</script>